module.exports = __webpack_public_path__ + "img/greennote-white.eb5fa28e.png";